import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductRiseAsync,
  deleteProductRiseAsync,
  editProductStyleAsync,
  editProductRiseAsync,
  getProductStyleAsync,
  getProductRiseAsync,
} from "../../../../store/services/productInfoServices";
const Rise = () => {
  const dispatch = useDispatch();
  const {
    getProductRiseStatus,
    getProductRiseError,
    getProductRiseData,
    addProductRiseStatus,
    addProductRiseData,
    addProductRiseError,

    editProductRiseStatus,
    editProductRiseError,
    editProductRiseData,

    deleteProductRiseData,
    deleteProductRiseStatus,
    deleteProductRiseError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductRiseAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductRiseData?.length
    ? getProductRiseData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedRise, setSelectedRise] = useState();
  const [addRiseMode, setAddRiseMode] = useState(false);
  const [addRiseData, setAddRiseData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedRise", selectedRise);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductRiseStatus === asyncStatus.SUCCEEDED) {
      setAddRiseMode(false);
      setSaveDisabled(true);
      setAddRiseData();
    }
  }, [, addProductRiseStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductRiseAsync(selectedRise?.rise_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductRiseStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedRise();
    }
  }, [, deleteProductRiseStatus]);
  useEffect(() => {
    if (editProductRiseStatus === asyncStatus.SUCCEEDED) {
      setSelectedRise();
      setEditMode(false);
    }
  }, [, editProductRiseStatus]);
console.log("getProductRiseData",getProductRiseData,editProductRiseData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this Rise?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Rise"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Rise Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddRiseMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addRiseMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addRiseMode || !selectedRise}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddRiseMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addRiseMode || !selectedRise}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductRiseStatus === asyncStatus.LOADING ||
                  editProductRiseStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addRiseData) {
                    dispatch(addProductRiseAsync(addRiseData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedRise, ...editData };
                    delete a.id;
                    dispatch(editProductRiseAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "rise_id", headerName: "ID", flex: true },
                  {
                    field: "rise_name",
                    headerName: "Rise Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedRise(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductRiseStatus === asyncStatus.IDLE ||
                  getProductRiseStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addRiseMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Rise:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddRiseData({
                            ...addRiseData,
                            rise_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddRiseData({
                            ...addRiseData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedRise ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedRise?.rise_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Rise:",
                    comp: (
                      <InputComp
                        key={selectedRise?.rise_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            rise_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedRise?.rise_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedRise?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedRise?.is_active ? true : false
                        }
                        checked={selectedRise?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any rise</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductRiseError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductRiseError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductRiseError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductRiseError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedRise(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedRise(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default Rise;
